import { IN_TEST_MODE } from '../constants';

/**
 * Receives non-fatal errors reported from shared helpers, with optional
 * structured context. Registered per runtime via {@link setSharedErrorReporter}.
 */
export type SharedErrorReporter = (
  error: Error,
  extras?: Record<string, unknown>,
) => void;

const defaultReporter: SharedErrorReporter = (error, extras) => {
  if (IN_TEST_MODE) return;
  console.error(error, extras);
};

let reporter: SharedErrorReporter = defaultReporter;

/**
 * Route {@link reportSharedError} calls to the host runtime, e.g. Sentry on
 * client and server. Falls back to `console.error` until registered.
 */
export const setSharedErrorReporter = (fn: SharedErrorReporter): void => {
  reporter = fn;
};

/** Report a non-fatal error from shared code through the registered {@link SharedErrorReporter}. */
export const reportSharedError = (
  error: Error,
  extras?: Record<string, unknown>,
): void => reporter(error, extras);
